/*
  dfm-toc.js — auto-generated Table of Contents for blog articles.

  Custom element <dfm-toc> scans the rendered article body for headings,
  assigns slug ids to any heading that lacks one, and builds a nested list
  of jump links. Vanilla ES6, no dependencies, defer-loaded.

  Modes (via data-auto):
    - "true"  : ignore manual entries, build links by scanning the DOM.
    - "false" : Liquid already rendered manual <li> entries; we only
                enhance them (scroll offset + smooth scroll + scrollspy).

  Why a DOM scan and not Liquid: Shopify's rich-text editor emits no ids on
  headings, so there is nothing for Liquid to anchor to. Scanning the
  rendered DOM also handles arbitrary heading nesting robustly.
*/
(function () {
  if (customElements.get('dfm-toc')) return; // guard against double-define

  // Turn heading text into a URL-safe slug: strip accents + punctuation,
  // collapse whitespace/underscores to single hyphens, trim stray hyphens.
  function slugify(text) {
    var s = text.toLowerCase().trim()
      .normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || 'section';
  }

  class DfmToc extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-toc-list]');
      this.offset = parseInt(this.dataset.offset, 10) || 0;

      var bodySelector = this.dataset.body || '.dfm-article__prose';
      this.bodies = Array.prototype.slice.call(document.querySelectorAll(bodySelector));

      if (this.dataset.auto === 'true') {
        this.buildAuto();
      } else {
        // Manual mode: just apply scroll offsets to the targets it points at.
        this.applyScrollMargins(this.collectTargets());
      }

      // Smooth-scroll + focus for every TOC link (auto or manual).
      this.addEventListener('click', this.onClick.bind(this));

      // Deep-link: if the page loaded with a #hash, re-align once margins set.
      if (location.hash) this.scrollToHash(location.hash, false);

      this.initScrollSpy();
    }

    buildAuto() {
      if (!this.list || this.bodies.length === 0) { this.hide(); return; }
      var levels = this.dataset.levels || 'h2, h3';

      // Seed the used-id set with every id already on the page so generated
      // slugs never collide with an existing anchor.
      var used = new Set(
        Array.prototype.slice.call(document.querySelectorAll('[id]'))
          .map(function (e) { return e.id; })
      );

      // Collect headings across ALL body sections, in document order.
      var headings = [];
      this.bodies.forEach(function (body) {
        Array.prototype.forEach.call(body.querySelectorAll(levels), function (h) {
          if (h.textContent.trim()) headings.push(h);
        });
      });
      if (headings.length === 0) { this.hide(); return; }

      var self = this;
      var lastH2Li = null, h2Sub = null, lastH3Li = null, h3Sub = null;

      function makeSub() {
        var ol = document.createElement('ol');
        ol.className = 'dfm-toc__sublist';
        return ol;
      }

      headings.forEach(function (h) {
        // Respect a hand-authored id; otherwise generate a unique slug.
        if (!h.id) {
          var base = slugify(h.textContent), slug = base, n = 2;
          while (used.has(slug)) { slug = base + '-' + n; n++; }
          h.id = slug;
        }
        used.add(h.id);
        h.style.scrollMarginTop = self.offset + 'px';

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);

        var level = h.tagName.toLowerCase();
        if (level === 'h2') {
          self.list.appendChild(li);
          lastH2Li = li; h2Sub = null; lastH3Li = null; h3Sub = null;
        } else if (level === 'h3') {
          li.classList.add('dfm-toc__subitem');
          if (lastH2Li) {
            if (!h2Sub) { h2Sub = makeSub(); lastH2Li.appendChild(h2Sub); }
            h2Sub.appendChild(li);
          } else {
            self.list.appendChild(li); // h3 before any h2 — keep it visible
          }
          lastH3Li = li; h3Sub = null;
        } else { // h4
          li.classList.add('dfm-toc__subitem', 'dfm-toc__subitem--deep');
          if (lastH3Li) {
            if (!h3Sub) { h3Sub = makeSub(); lastH3Li.appendChild(h3Sub); }
            h3Sub.appendChild(li);
          } else if (lastH2Li) {
            if (!h2Sub) { h2Sub = makeSub(); lastH2Li.appendChild(h2Sub); }
            h2Sub.appendChild(li);
          } else {
            self.list.appendChild(li);
          }
        }
      });
    }

    // Gather the heading elements the current links point at.
    collectTargets() {
      var targets = [];
      Array.prototype.forEach.call(this.querySelectorAll('a[href^="#"]'), function (a) {
        var id = decodeURIComponent(a.getAttribute('href').slice(1));
        var t = id && document.getElementById(id);
        if (t) targets.push(t);
      });
      return targets;
    }

    applyScrollMargins(els) {
      var o = this.offset;
      els.forEach(function (e) { e.style.scrollMarginTop = o + 'px'; });
    }

    onClick(e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || !this.contains(a)) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      if (!document.getElementById(id)) return;
      e.preventDefault();
      this.scrollToHash('#' + id, true);
    }

    scrollToHash(hash, smooth) {
      var id = decodeURIComponent(hash.slice(1));
      var target = document.getElementById(id);
      if (!target) return;
      target.style.scrollMarginTop = this.offset + 'px';

      // Compute the destination explicitly so the sticky-header offset is
      // honored regardless of scroll-margin support.
      var startY = window.pageYOffset || document.documentElement.scrollTop;
      var top = target.getBoundingClientRect().top + startY - this.offset;
      if (top < 0) top = 0;

      if (smooth) {
        window.scrollTo({ top: top, behavior: 'smooth' });
        // Some environments no-op smooth scrolling (and a native anchor would
        // at least jump). If we haven't moved shortly after, jump instantly.
        setTimeout(function () {
          if (Math.abs((window.pageYOffset || 0) - startY) < 2 && Math.abs(top - startY) > 2) {
            window.scrollTo(0, top);
          }
        }, 80);
      } else {
        window.scrollTo(0, top);
      }

      if (history.replaceState) history.replaceState(null, '', '#' + id);
      // a11y: move focus to the heading without yanking the scroll position.
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }

    // Highlight the link for the heading currently nearest the top.
    initScrollSpy() {
      if (!('IntersectionObserver' in window)) return;
      var links = Array.prototype.slice.call(this.querySelectorAll('a[href^="#"]'));
      if (!links.length) return;
      var map = new Map();
      links.forEach(function (a) {
        var id = decodeURIComponent(a.getAttribute('href').slice(1));
        var t = id && document.getElementById(id);
        if (t) map.set(t, a);
      });
      if (!map.size) return;

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var a = map.get(en.target);
          if (!a) return;
          links.forEach(function (l) { l.classList.remove('is-active'); });
          a.classList.add('is-active');
        });
      }, { rootMargin: '-' + (this.offset + 10) + 'px 0px -65% 0px', threshold: 0 });

      map.forEach(function (a, t) { obs.observe(t); });
    }

    hide() { this.style.display = 'none'; }
  }

  customElements.define('dfm-toc', DfmToc);
})();
